export default class LocalStorageService {
    storagePrefix;
    constructor(storagePrefix) {
        this.storagePrefix = storagePrefix;
    }
    saveData(key, data) {
        const storageKey = this.getStorageKey(key.toString());
        localStorage.setItem(storageKey, JSON.stringify(data));
    }
    getData(key, parseFunction) {
        const storageKey = this.getStorageKey(key.toString());
        const storedData = localStorage.getItem(storageKey);
        return parseFunction(storedData, (defaultData) => this.saveData(key, defaultData));
    }
    getStorageKey(key) {
        return `${this.storagePrefix}_${key}`;
    }
}
